import React from 'react';
import { Wrapper } from '../../../components/Wrapper';
import { ToastContainer } from 'react-toastify';
import If, { Else } from 'if-else-react';
import ForgotPasswordController, {
  useForgotPasswordContext,
} from '../../../controller/auth/forgot_password';

const ForgotForm: React.FC = () => {
  // call method and state from controller
  const { setEmail, handleResetPassword } = useForgotPasswordContext();
  const { isLoading } = useForgotPasswordContext().state;

  const onSubmitResetPassword = (e) => {
    e.preventDefault();
    handleResetPassword(e.target.value);
  };

  return (
    <div className="max-w-2xl mx-auto lg:px-7 pt-4 pb-18 w-full text-center mt-5 mb-5">
      <h1 className="text-2xl md:text-3xl font-semibold">Reset Password</h1>
      {/* Form Login */}
      <div className="w-5/6 mx-auto mt-8">
        <div className="bg-white rounded-lg overflow-hidden mb-10">
          <div className="p-5 sm:p-7 md:p-6 xl:p-7 w-10/12 mx-auto">
            <p className="text-sm font-normal text-gray-400 pb-5 text-center">
              Masukkan email anda pada kotak yang telah disediakan.
            </p>

            {/* Divider */}
            <div className="border-b-2 border-dashed"></div>
            {/* /Divider */}

            {/* Form */}
            <form className="mt-5" onSubmit={(e) => onSubmitResetPassword(e)}>
              <div className="border-3 border-gray-400 mt-2">
                {/* Username */}
                <p className="text-sm text-left mb-2">Email</p>
                <div className="relative text-gray-700">
                  <i className="fas fa-envelope absolute mt-3 ml-4 text-gray-300 focus:text-green-600"></i>
                  <input
                    className="w-full h-10 pl-10 pr-8 text-base placeholder-gray-300 border-1 border-gray-300 rounded-lg focus:border-green-600 focus:ring-1 focus:ring-green-600"
                    placeholder="Email"
                    type="text"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              {/* /Form */}

              {/* Divider */}
              <div className="border-b-2 border-dashed mt-5"></div>
              {/* /Divider */}

              {/* Footer Sign In */}
              <div className="flex justify-between items-center mt-5">
                <button
                  type="submit"
                  className="py-2 px-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 md:py-3 md:text-md md:px-5 w-full"
                >
                  <If condition={isLoading}>
                    <svg
                      role="status"
                      className="inline mr-3 w-4 h-4 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                    Loading...
                    <Else />
                    Reset Password
                  </If>
                </button>
              </div>
              {/* /Footer Sign In */}
            </form>

            {/* Sign Up Link */}
            <div className="mt-5">
              <p className="text-sm text-gray-300">
                Sudah memiliki akun pintar?
              </p>
              <a
                href="/login"
                className="text-sm text-green-600 hover:text-green-700"
              >
                Login Disini
              </a>
            </div>
            {/* /Sign Up Link */}
          </div>
        </div>
      </div>
    </div>
  );
};

const WrapperMain: React.FC = () => {
  return (
    <Wrapper>
      {/* Content */}
      <ForgotForm />
    </Wrapper>
  );
};

const ForgotPassword: React.FC = () => {
  return (
    <ForgotPasswordController.Provider>
      <ToastContainer
        position="top-center"
        style={{ width: '60%', marginTop: '5%' }}
      />
      <WrapperMain />
    </ForgotPasswordController.Provider>
  );
};

export default ForgotPassword;
